<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.ID }}</td>
                <td><strong>{{ item.Address || 'N/A' }}</strong></td>
                <td style="max-width: 320px; word-break: break-word;">{{ item.Body }}</td>
                <td>
                  <template v-if="item.CustomerID">
                    <a
                      href="javascript:void(0)"
                      class="primary--text font-weight-bold text-decoration-none"
                      @click="gotoCustomerDetail(item.CustomerID)"
                    >
                      {{ item.Username || getCustomerUsername(item.CustomerID) || ('#' + item.CustomerID) }}
                    </a>
                  </template>
                  <span v-else class="grey--text">-</span>
                </td>
                <td class="text-end">
                  <strong v-if="item.Amount" class="success--text">{{ item.Amount | currency }}</strong>
                  <span v-else class="grey--text">0 ₫</span>
                </td>
                <td>
                  <v-chip v-if="item.Status == 1" small color="success" text-color="white">
                    Thành công
                  </v-chip>
                  <v-chip v-else-if="item.Status == 2" small color="grey darken-1" text-color="white">
                    Hủy
                  </v-chip>
                  <v-chip v-else small color="error" text-color="white">
                    Lỗi
                  </v-chip>
                </td>
                <td style="max-width: 250px; word-break: break-word;" class="caption">
                  {{ item.Message }}
                </td>
                <td>
                  <template v-if="item.RechargeID">
                    <a
                      href="javascript:void(0)"
                      class="primary--text font-weight-bold text-decoration-none"
                      @click="gotoRechargeDetail(item.RechargeID)"
                    >
                      #{{ item.RechargeID }}
                    </a>
                  </template>
                  <span v-else class="grey--text">-</span>
                </td>
                <td>
                  <span v-if="item.ModifiedBy" class="font-weight-medium">{{ item.ModifiedBy }}</span>
                  <span v-else class="grey--text">-</span>
                </td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td class="text-no-wrap">
                  <template v-if="item.Status == 0">
                    <v-btn small color="primary" class="mr-2" @click="openRechargeDialog(item)">
                      <v-icon left small>fa-money-bill-wave</v-icon> Nạp tiền
                    </v-btn>
                    <v-btn small color="error" outlined @click="openCancelDialog(item)">
                      <v-icon left small>fa-ban</v-icon> Hủy
                    </v-btn>
                  </template>
                  <span v-else class="grey--text">-</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Dialog nạp tiền thủ công -->
    <v-dialog v-model="rechargeDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">fa-money-bill-wave</v-icon>
          Nạp tiền thủ công
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert v-if="selectedItem" dense outlined type="info" class="mb-3 caption">
            <div><strong>Ngân hàng / App:</strong> {{ selectedItem.Address || 'N/A' }}</div>
            <div class="mt-1"><strong>Nội dung tin nhắn:</strong> {{ selectedItem.Body }}</div>
          </v-alert>

          <v-form ref="rechargeForm" v-model="rechargeValid" lazy-validation>
            <v-autocomplete
              v-model="rechargeData.customer_id"
              :items="customerOptions"
              item-text="displayText"
              item-value="ID"
              label="Chọn khách hàng *"
              :rules="[v => !!v || 'Vui lòng chọn khách hàng cần nạp tiền']"
              placeholder="Tìm theo Tên hoặc Mã KH (VD: NT9817)..."
              clearable
              outlined
              dense
            ></v-autocomplete>

            <h-currency-input
              v-model="rechargeData.amount"
              label="Số tiền cần nạp (VNĐ) *"
              :decimal="0"
              class="mt-2"
            ></h-currency-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="rechargeDialog = false" :disabled="submitting">
            Đóng
          </v-btn>
          <v-btn color="primary" @click="confirmManualRecharge" :loading="submitting">
            Xác nhận nạp tiền
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog xác nhận hủy -->
    <v-dialog v-model="cancelDialog" max-width="450px">
      <v-card>
        <v-card-title class="headline error white--text">
          <v-icon left color="white">fa-exclamation-triangle</v-icon>
          Xác nhận hủy tin nhắn
        </v-card-title>
        <v-card-text class="pt-4">
          <p>Bạn có chắc chắn muốn hủy tin nhắn nạp tiền <strong>#{{ selectedItem ? selectedItem.ID : '' }}</strong> không?</p>
          <div v-if="selectedItem" class="caption grey--text text--darken-1">
            Nội dung: {{ selectedItem.Body }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelDialog = false" :disabled="submitting">
            Đóng
          </v-btn>
          <v-btn color="error" @click="confirmCancelLog" :loading="submitting">
            Xác nhận hủy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      search: "",
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngân hàng / App",
          value: "Address",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Nội dung tin nhắn",
          value: "Body",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Số tiền nạp",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: [
            { text: "Thành công", value: 1 },
            { text: "Lỗi", value: 0 },
            { text: "Hủy", value: 2 }
          ]
        },
        {
          text: "Ghi chú / Lý do",
          value: "Message",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Mã nạp (RechargeID)",
          value: "RechargeID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thời gian",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Thao tác",
          value: "actions",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"] },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "auto_topup_log_list",
      filterConditions: [],
      quickFilterConditions: [],

      // Dialogs
      rechargeDialog: false,
      cancelDialog: false,
      selectedItem: null,
      rechargeValid: true,
      rechargeData: {
        id: null,
        customer_id: null,
        amount: 0
      },
      submitting: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.autoTopupLog.all.data,
      total_rows: state => state.autoTopupLog.all.total,
      loading: state => state.autoTopupLog.loading,
      customers: state => state.customer.master.data || []
    }),
    customerOptions() {
      if (!this.customers || !Array.isArray(this.customers)) return [];
      return this.customers.map(c => ({
        ...c,
        displayText: `${c.Username || ''} ${c.UserCode ? '(' + c.UserCode + ')' : ''} - #${c.ID}`
      }));
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("autoTopupLog/getList", param);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
        is_master: 1,
        fields: ["ID", "Username", "UserCode"]
      });
    },
    parseAmountFromBody(body) {
      if (!body) return 0;
      let match = body.match(/\+\s*([0-9][0-9.,]*)/);
      if (!match) {
        match = body.match(/([0-9][0-9.,]*)\s*(?:VND|VNĐ|đ|dong|Đ|d)/i);
      }
      if (match) {
        let rawNum = match[1].replace(/[.,]+$/, '');
        if (rawNum.includes(',') && rawNum.includes('.')) {
          if (rawNum.lastIndexOf('.') > rawNum.lastIndexOf(',')) {
            rawNum = rawNum.replace(/,/g, '');
          } else {
            rawNum = rawNum.replace(/\./g, '').replace(/,/g, '.');
          }
        } else if (rawNum.includes(',')) {
          let parts = rawNum.split(',');
          if (parts.length > 1 && parts.slice(1).every(p => p.length === 3)) {
            rawNum = parts.join('');
          } else {
            rawNum = rawNum.replace(/,/g, '.');
          }
        } else if (rawNum.includes('.')) {
          let parts = rawNum.split('.');
          if (parts.length > 1 && parts.slice(1).every(p => p.length === 3)) {
            rawNum = parts.join('');
          }
        }
        let val = parseFloat(rawNum);
        return !isNaN(val) && val > 0 ? val : 0;
      }
      return 0;
    },
    openRechargeDialog(item) {
      this.selectedItem = item;
      let parsedAmount = item.Amount && item.Amount > 0 ? item.Amount : this.parseAmountFromBody(item.Body);

      let matchedCustomerId = item.CustomerID || null;
      if (!matchedCustomerId && item.Body && this.customers && this.customers.length > 0) {
        let matchCode = item.Body.match(/\b(NT\s*[A-Z0-9]+)\b/i);
        if (matchCode) {
          let code = matchCode[1].replace(/\s+/g, '').toUpperCase();
          let found = this.customers.find(c => c.UserCode && c.UserCode.toUpperCase() === code);
          if (found) {
            matchedCustomerId = found.ID;
          }
        }
      }

      this.rechargeData = {
        id: item.ID,
        customer_id: matchedCustomerId,
        amount: parsedAmount
      };
      this.rechargeDialog = true;
      this.$nextTick(() => {
        if (this.$refs.rechargeForm) {
          this.$refs.rechargeForm.resetValidation();
        }
      });
    },
    confirmManualRecharge() {
      if (this.$refs.rechargeForm && !this.$refs.rechargeForm.validate()) {
        return;
      }
      if (!this.rechargeData.customer_id) {
        sendErrorNotice("Vui lòng chọn khách hàng.");
        return;
      }
      if (!this.rechargeData.amount || this.rechargeData.amount <= 0) {
        sendErrorNotice("Số tiền nạp phải lớn hơn 0.");
        return;
      }
      this.submitting = true;
      this.$store
        .dispatch("autoTopupLog/manualRecharge", {
          data: {
            id: this.rechargeData.id,
            customer_id: this.rechargeData.customer_id,
            amount: this.rechargeData.amount
          },
          onSuccess: () => {
            this.submitting = false;
            this.rechargeDialog = false;
            this.filter_data();
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    openCancelDialog(item) {
      this.selectedItem = item;
      this.cancelDialog = true;
    },
    confirmCancelLog() {
      if (!this.selectedItem || !this.selectedItem.ID) return;
      this.submitting = true;
      this.$store
        .dispatch("autoTopupLog/cancelLog", {
          id: this.selectedItem.ID,
          onSuccess: () => {
            this.submitting = false;
            this.cancelDialog = false;
            this.filter_data();
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    gotoCustomerDetail(id) {
      if (!id) return;
      let routeData = this.$router.resolve({
        name: "CustomerDetail",
        params: {
          Pid: id,
          title: `Khách hàng (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    gotoRechargeDetail(id) {
      if (!id) return;
      let routeData = this.$router.resolve({
        name: "RechargeDetail",
        params: {
          Pid: id,
          title: `Nạp tiền (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    getCustomerUsername(customerId) {
      if (!customerId || !this.customers || !Array.isArray(this.customers)) return "";
      let found = this.customers.find(c => c.ID == customerId);
      return found ? found.Username : "";
    }
  },
  mounted() {
    this.getCustomerList();
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
